module.exports = __webpack_public_path__ + "img/people_fill.cbd5e1b2.png";